import axios from 'axios';

// Create an Axios instance
const api = axios.create({
  baseURL: 'https://veelion.com/api/', // Replace with your backend URL
});

// Request interceptor to add the access token to headers
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('accessToken');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor to handle token refresh
// Request interceptor to add the access token to headers
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('accessToken');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor to handle token refresh
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // Check if the error is due to an expired token and the request hasn't been retried yet
    if (
      error.response?.status === 401 && // Check for 401 Unauthorized specifically
      !originalRequest._retry &&
      !originalRequest.url.endsWith('/login') // Exclude login endpoint
    ) {
      originalRequest._retry = true;

      try {
        const accessToken = localStorage.getItem('accessToken');
        const response = await api.post('/refresh', { accessToken });

        // Update the access token in localStorage
        localStorage.setItem('accessToken', response.data.access_token);

        // Retry the original request with the new token
        return api(originalRequest);
      } catch (refreshError) {
        // If the refresh token is invalid or expired, log the user out
        localStorage.removeItem('accessToken');
        localStorage.removeItem('user');

        // Redirect to the login page with a message
        window.location.href = '/login?message=session_expired';
        return Promise.reject(refreshError);
      }
    }

    // If the error is not related to token expiration, reject the promise
    return Promise.reject(error);
  }
);


// Add pending projects API methods// In your api file

export const fetchPendingProjects = async (params = {}) => {
  // Convert to backend-compatible parameter names if needed
  const formattedParams = {
    page: params.page,
    per_page: params.pageSize,
    search: params.search,
    status: params.status,
  };
  
  const response = await api.get('/pending-projects', { 
    params: formattedParams 
  });
  return response.data;
};


export const acceptProject = async (projectId) => {
  const response = await api.post(`/projects/${projectId}/accept`);
  return response.data;
};

export const rejectProject = async (projectId) => {
  const response = await api.post(`/projects/${projectId}/reject`);
  return response.data;
};

export default api;